export default __webpack_public_path__ + "static/media/Dropbox.838f1263.svg";